/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PerpetualPair } from './perpetualPair';

/**
 * Funding Rate Payment DTO.
 */
export interface FundingRatePaymentDto {
  /**
   * Unique identifier of the payment record
   */
  id?: number;
  /**
   * Associated perpetual trading pair
   */
  perpetualPair?: PerpetualPair;
  /**
   * Payment amount
   */
  amount?: number;
  /**
   * Timestamp when the payment occurred
   */
  timestamp?: string;
  /**
   * External payment identifier
   */
  paymentId?: string;
}
